<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-12 text-right" v-if="panico.atendido == 'Não'">
          <button class="btn btn-sm btn-primary" @click="setAtendido">Marcar como atendido</button>
        </div>
        <div class="col-md-6">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="panico.usuario.name" disabled/>
        </div>
        <div class="col-md-6">
          <label>Local</label>
          <input type="text" class="form-control" v-model="panico.local.nome" disabled/>
        </div>
        <div class="col-md-6">
          <label>Responsável</label>
          <input type="text" class="form-control" v-model="panico.responsavel.name" disabled/>
        </div>
        <div class="col-md-3">
          <label>Atendido</label>
          <input type="text" class="form-control" v-model="panico.atendido" disabled/>
        </div>
        <div class="col-md-3">
          <label>Data de acionamento</label>
          <input type="text" class="form-control" v-model="panico.created_at_f" disabled/>
        </div>
        <div class="col-md-12 text-right">
          <hr />
          <router-link to="/panicos" class="btn btn-back">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      panico: {},
    };
  },
  computed: {},
  methods: {
    getPanicos: function (id) {
      const self = this;
      const api = self.$store.state.api + `panicos/${id}?with[]=local&with[]=responsavel&with[]=usuario`;

      axios
        .get(api)
        .then((response) => {
          self.panico = response.data.data[0];

          self.panico.atendido = self.panico.atendido ? "Sim" : "Não";

          if(!self.panico.responsavel_id)
          {
            self.panico.responsavel = [];
            self.panico.responsavel.name = "Não atribuido";
          }

          if(!self.panico.local_id)
          {
            self.panico.local = [];
            self.panico.local.nome = "Não logado / indisponível";
          }

          self.$loading(false);
          self.setLoader(50);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    setAtendido: function () {
      const self = this;
      const api = self.$store.state.api + "set-atendido/" + self.panico.id;

      self.$loading(true);

      axios
        .post(api, self.panico)
        .then(() => {
          self.getPanicos(self.panico.id);
          self.loader = 50;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    if (id) {
      self.setLoader(50);

      self.getPanicos(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>